import { Link } from 'react-router-dom';
import {
  UserOutlined,
  ProjectOutlined,
  ApiOutlined,
  ReadOutlined,
  SolutionOutlined,
} from '@ant-design/icons';

export const getMenuItems = () => {
  const getItem = (label, key, icon, path) => {
    return {
      key,
      icon,
      label: <Link to={path}>{label}</Link>,
    };
  };

  return [
    getItem('Admin-Users', '1', <UserOutlined />, '/'),
    getItem('Users', '2', <UserOutlined />, '/users'),
    getItem('Projects', '3', <ProjectOutlined />, '/projects'),
    getItem('Services', '4', <ApiOutlined />, '/services'),
    getItem('Blogs', '5', <ReadOutlined />, '/blogs'),
    getItem('Add-Jobs', '6', <SolutionOutlined />, '/jobs'),
    getItem('Job-Management', '7', <SolutionOutlined />, '/job-management'),
  ];
};